import React from "react";

export default function ProficiencyLevels_RU() {
  return (
    <>
      <h2>Объяснение уровней квалификации</h2>
      <div>
        Чтобы лучше понять свой личный профиль компетентности, вам следует посмотреть на свои показатели
        по областям. Это должно дать вам первоначальную идею, которая поможет вам определить ваши
        относительные слабые и сильные стороны, а также даст вам предложения и идеи для дальнейшего
        развития вашей цифровой практики.
        <ul>
          <li>A1: до 32/192 баллов, до 17%</li>
          <li>A2: 33–64/192 баллов, 18–33%</li>
          <li>B1: 65-96/192 баллов, 34-50%</li>
          <li>B2: 97-128/192 баллов, 51-67%</li>
          <li>С1: 129-160/192 баллов, 68-83%</li>
          <li>C2: 161-192/192 баллов, 84-100%</li>
          <li>D1: 0/192 баллов, 0%</li> 
        </ul>
      </div>
      <div>
        <h3>Новичок (A1)</h3>
        <div style={{ marginBottom: "20px" }}>
          Вы знаете, как цифровые технологии могут поддержать и улучшить вашу профессиональную
          деятельность. Обратная связь, которую вы получаете от этой саморефлексии, определила ряд
          действий, которые вы можете попробовать. Выберите один или два, чтобы спланировать свой
          следующий путь обучения, сосредоточив внимание на значительном улучшении ваших стратегий
          обучения. Сделав это, вы обнаружите, что переходите на следующий уровень цифровой
          компетентности — уровень исследователя.
        </div>
      </div>
      <div>
        <h3>Исследователь (A2)</h3>
        <div style={{ marginBottom: "20px" }}>
          Вы начали изучать потенциал цифровых технологий и заинтересованы в их использовании для
          повышения педагогической и профессиональной практики. Вы пытались использовать цифровые
          технологии в некоторых областях и выиграете от их более последовательного использования. Вы
          можете повысить свою компетентность, используя цифровые технологии в различных контекстах и для
          различных целей, интегрируя их своей практики. Это поднимет вас на следующий уровень цифровой
          компетентности — уровень интегратора.
        </div>
      </div>
      <div>
        <h3>Интегратор (B1)</h3>
        <div style={{ marginBottom: "20px" }}>
          Вы экспериментируете с цифровыми технологиями в различных контекстах и для различных целей,
          интегрируя их в свою практику. Вы творчески используете их для улучшения различных аспектов
          вашей профессиональной деятельности. Вы стремитесь расширить свой опыт. Вы выиграете, увеличив
          свое понимание того, какие инструменты лучше всего работают в каких ситуациях, а также
          приспособив цифровые технологии к педагогическим стратегиям и методам. Постарайтесь дать себе
          еще немного времени для размышлений и адаптации, дополненных совместной поддержкой и обменом
          знаниями, чтобы перейти к следующему шагу, эксперту.
        </div>
      </div>
      <div>
        <h3>Эксперт (B2)</h3>
        <div style={{ marginBottom: "20px" }}>
          Вы используете ряд цифровых технологий уверенно, творчески и критически, чтобы улучшить свою
          профессиональную деятельность. Вы целенаправленно выбираете цифровые технологии для конкретных
          ситуаций и пытаетесь понять преимущества и недостатки различных цифровых стратегий. Вы
          любопытны и открыты для новых идей, зная, что есть много вещей, которые вы еще не пробовали. Вы
          используете эксперименты и размышления как средство перепроектирования, расширения,
          структурирования и консолидации своих стратегий. Поделитесь своим опытом с другими учителями и
          продолжайте критически развивать свои цифровые стратегии, чтобы достичь уровня лидера.
        </div>
      </div>
      <div>
        <h3>Лидер (С1)</h3>
        <div style={{ marginBottom: "20px" }}>
          У вас последовательный и комплексный подход к использованию цифровых технологий для повышения
          педагогической и профессиональной практики. Вы полагаетесь на широкий набор цифровых стратегий,
          из которых знаете, как выбрать наиболее подходящую для любой конкретной ситуации. Вы постоянно
          размышляете и совершенствуете свою практику. Общаясь со сверстниками, вы всегда в курсе новых
          разработок и идей и помогаете другим учителям использовать потенциал цифровых технологий для
          улучшения преподавания и обучения. Если вы готовы еще немного поэкспериментировать, привлекая
          учащихся к расширению потенциала цифровых технологий на школьном уровне и за его пределами, вы
          сможете достичь высшей ступени компетентности в качестве первопроходца.
        </div>
      </div>
      <div>
        <h3>Новатор (С2)</h3>
        <div style={{ marginBottom: "20px" }}>
          Вы критически осознаете адекватность современных цифровых и педагогических практик, в которых
          являетесь Лидером. Вы обеспокоены ограничениями или недостатками этих практик и движимы
          импульсом к еще большим инновациям в образовании. Вы экспериментируете с инновационными и
          сложными цифровыми технологиями и/или разрабатываете новые педагогические подходы. Вы
          руководите инновациями в своей школе и являетесь образцом для подражания для других учителей.
          Вы расширяете свою практику за пределы школьного сообщества и привлекаете заинтересованные
          стороны для дальнейшего развития. Продолжайте быть открытыми для новых идей и не отставайте от
          непрерывных технологических и педагогических достижений, чтобы улучшить свои творческие и
          инновационные решения.
        </div>
      </div>
      <div>
        <h3>Цифровая Некомпетентность (D1)</h3>
        <div style={{ marginBottom: "20px" }}>
          Вы находитесь сейчас в самом начале цифрового пути в образовании. Возможно, огромный мир
          цифровых инструментов и технологий кажется вам незнакомым и немного подавляющим. Вероятно, вы
          еще не исследовали и не использовали многие имеющиеся цифровые стратегии в обучении, но вы
          обладаете искренним любопытством и желанием учиться. Отправляясь в это путешествие, помните,
          что каждый с чего-то начинает. Имея необходимые ресурсы и поддержку, вы вскоре найдете свою
          опору и откроете для себя безграничные возможности, которые цифровая интеграция предлагает для
          улучшения вашего преподавания.
        </div>
      </div>
    </>
  );
}
